import "./FeaturesSection.css";

import Ingredients from "../../assets/images/Quality.png";
import Flavours from "../../assets/images/Range.png";
import Price from "../../assets/images/Pocket.png";
import Delivery from "../../assets/images/Delivery.png";

const features = [
  {
    img: Ingredients,
    title: "Premium Quality Ingredients",
    description:
      "We use only the finest quality ingredients in our baking process to ensure every bite is perfect.",
  },
  {
    img: Flavours,
    title: "Wide Range of Flavours",
    description:
      "From classic vanilla to exotic mango, we offer diverse flavors that appeal to all ages and tastes.",
  },
  {
    img: Price,
    title: "Pocket-Friendly Price",
    description:
      "Quality doesn't have to be expensive. Our products are priced affordably for everyone to enjoy.",
  },
  {
    img: Delivery,
    title: "Fast & Fresh Delivery",
    description:
      "We ensure reliable and timely delivery so you always get fresh, crispy biscuits at your doorstep.",
  },
];

export default function FeaturesSection() {
  return (
    <section className="features-section">
      <div className="container">
        <h2 className="section-title">Our Features</h2>
        <p className="section-subtitle">
          Deliciously Crafted — That’s What Makes Bear Bitz Your Best Bite!
        </p>

        <div className="features-grid">
          {features.map((feature, index) => (
            <div className="feature-card" key={index}>
              <div className="feature-icon" aria-hidden="true">
                <img src={feature.img} alt={feature.title} />
              </div>
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
